import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'
import { pageContentDefaultSize } from 'style/emotion'

const JsonformContainer = styled('section')`
  ${pageContentDefaultSize}
  margin-bottom: 32px;
  padding-top: 1.5rem;

  ${mediaQuery('', 'laptop')} {
    padding-top: 3rem;
  }

  .question-breadcrumb {
    font-size: 14px;
    font-weight: 500;
    color: #173237;
    line-height: normal;
    margin-bottom: 1rem;
  }

  .error-header {
    background-color: #fce9eb;
    color: #173237;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #e12339;
    padding: 8px;
    margin-bottom: 1rem;

    .mdi-alert-rhombus {
      color: #e12339;
      margin-right: 10px;
    }
  }

  .question-description {
    font-size: 25px;
    font-weight: 300;
    color: #374b50;
    line-height: 27.5px;

    ${mediaQuery('mobile')} {
      margin-bottom: 0px;
    }
  }

  .question-subheader {
    font-size: 14px;
    font-weight: 400;
    color: #173237;
    margin-top: 0.5rem;
    line-height: 20px;
  }
  .MuiPaper-root {
    box-shadow: none !important;

    .MuiCardHeader-root {
      padding: 0px 0px 0px 0px !important;
      margin-bottom: 16px;
      .MuiCardHeader-title {
        font-size: 16px !important;
        font-weight: 500 !important;
        color: #173237 !important;
      }
    }

    .MuiCardContent-root {
      padding: 0px 0px 0px 0px !important;
    }
  }

  .accordion {
    .card {
      .card-body {
        background-color: #fff !important;
        padding: 0px !important;
      }
    }
    margin-bottom: 24px;
    margin-top: 24px;
  }

  .custom-input-label {
    font-size: 14px;
    font-weight: 500;
    color: #173237;
    margin-bottom: 0.4rem;
  }

  .custom-date-label {
    font-size: 14px;
    font-weight: 500;
    color: #173237;
    margin-bottom: 0.4rem;
  }

  .custom-radio-button-label {
    font-size: 16px;
    font-weight: 500;
    color: #173237;
    margin-bottom: 1rem;
    line-height: 18.75px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .custom-object-label {
    font-size: 16px;
    font-weight: 500;
    color: #455b5f;
    margin-bottom: 1rem;
  }

  .MuiGrid-spacing-xs-2 > .MuiGrid-item {
    /* padding: 8px; */
    padding-top: 16px;
    padding-bottom: 0px;
    padding-right: 8px;
    padding-left: 8px;
    ${mediaQuery('mobile')} {
      padding-top: 0px;
    }
  }

  .MuiGrid-spacing-xs-2.MuiGrid-container {
    ${mediaQuery('mobile')} {
      display: block;
      margin-top: 16px;
    }
  }

  .form-control.is-invalid {
    background-image: none;
    background-color: #fce9eb;
    border-color: #e12339;
  }

  .text-danger {
    color: #e12339;
    line-height: 16px;
  }
`

const ButtonsContainer = styled('section')`
  ${pageContentDefaultSize}
  .questionnaire-read-only-back-container {
    display: flex;
    width: 100%;
    margin: auto;
    ${mediaQuery('', 'tablet')} {
      width: 50%;
    }
    & > button {
      width: 100%;
    }
  }
`
export { JsonformContainer, ButtonsContainer }
